















import { Component, Vue } from 'vue-property-decorator'
import HIVEAppBar from '@/components/common/HIVEAppBar.vue'
import authStore from '@/store/modules/authentication'

@Component({
  components: {
    HIVEAppBar,
  },
})
export default class App extends Vue {
  /** isLoggedIn is a computed property that returns a boolean if the user is logged in or not
   * @returns boolean
   */
  private get isLoggedIn() {
    return this.$store.state.authentication.appUser.isLoggedIn
  }

  /** isCTCSoftware is a computed property that returns a boolean if a user trying to sign in is within the ctc software organization.
   * @returns boolean
   */
  private get isCTCSoftware() {
    if (this.$store.state.authentication.appUser.organization.type === 1000) {
      return true
    } else {
      return false
    }
  }

  /** Lifecycle Methods */
  private created() {
    this.$store.dispatch('authentication/signIn')
  }
}
